import {
  ConnectorNotConnectedError,
  type BaseError,
  type Connector,
  type ConnectorNotConnectedErrorType,
  type ErrorType,
} from '@particle-network/connector-core';
import type { Config } from '../createConfig';

export type SwitchAccountParameters = {
  connector: Connector;
};

export type SwitchAccountReturnType = {
  accounts: readonly [string, ...string[]];
  chainId: number;
};

export type SwitchAccountErrorType = ConnectorNotConnectedErrorType | BaseError | ErrorType;

export async function switchAccount(
  config: Config,
  parameters: SwitchAccountParameters
): Promise<SwitchAccountReturnType> {
  const { connector } = parameters;

  const connection = config.state.connections.get(connector.uid);
  if (!connection) throw new ConnectorNotConnectedError();

  await config.storage?.setItem('recentConnectorId', connector.id);
  config.setState((x) => ({
    ...x,
    current: connector.uid,
  }));
  return {
    accounts: connection.accounts,
    chainId: connection.chainId,
  };
}
